import { Box, Button, Link } from '@material-ui/core';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import { ShoppingCartOrder } from '@src/types/shopify';
import dayjs from 'dayjs';
import { CSSProperties } from 'react';

export interface IOrderHistoryItem {
  labels: { [key: string]: string };
  item: ShoppingCartOrder;
  handleSendOrderUrl: () => void;
  handleOpenOrderUrl: () => void;
}

export const OrderHistoryItem: React.FC<IOrderHistoryItem> = ({
  item,
  labels,
  handleSendOrderUrl,
  handleOpenOrderUrl,
}) => {
  const {
    orderNumber: orderNumberLabel,
    orderDate,
    orderQuantity,
    orderSubTotal,
    orderTax,
    orderShipping,
    orderTotalAmount,
    orderState,
    sendUrlButton,
  } = labels;

  const {
    orderNumber,
    orderAt,
    productQuantity,
    status,
    totalAmount,
    subTotal,
    totalTax,
    totalShipping,
  } = item;
  const { amount, currencyCode } = totalAmount;
  const { amount: subTotalAmount } = subTotal;
  const { amount: totalTaxAmount } = totalTax;
  const { amount: totalShippingAmount } = totalShipping;

  const formatedSubTotalAmount = useCurrencyFormat({
    value: subTotalAmount,
    currency: currencyCode,
  });

  const formattedTotalTaxAmount = useCurrencyFormat({
    value: totalTaxAmount,
    currency: currencyCode,
  });

  const formattedTotalShippingAmount = useCurrencyFormat({
    value: totalShippingAmount,
    currency: currencyCode,
  });

  const formattedAmount = useCurrencyFormat({
    value: amount,
    currency: currencyCode,
  });

  const commonStyle: CSSProperties = {
    lineHeight: '120%',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      boxShadow="4px 0px 4px rgba(0, 0, 0, 0.08), -4px 0px 4px rgba(0, 0, 0, 0.08), 0px 4px 4px rgba(0, 0, 0, 0.08)"
      borderRadius="8px"
      padding={1}
      marginBottom={1}
      style={{ gap: 8 }}
    >
      <Box
        id={`order-history-item-${item.orderNumber}`}
        display="flex"
        style={{ gap: 8 }}
      >
        <Box fontWeight={600} fontSize={10} style={{ ...commonStyle, gap: 8 }}>
          <Box>{orderNumberLabel}</Box>
          <Box>{orderDate}</Box>
          <Box>{orderQuantity}</Box>
          <Box>{orderSubTotal}</Box>
          <Box>{orderTax}</Box>
          <Box>{orderShipping}</Box>
          <Box>{orderTotalAmount}</Box>
          <Box>{orderState}</Box>
        </Box>
        <Box fontSize={10} style={{ ...commonStyle, gap: 8 }}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link href="#" onClick={handleOpenOrderUrl}>
            {orderNumber}
          </Link>
          <Box>{dayjs(orderAt).format('DD/MM/YYYY HH:mm a')}</Box>
          <Box>{productQuantity}</Box>
          <Box>{formatedSubTotalAmount}</Box>
          <Box>{formattedTotalTaxAmount}</Box>
          <Box>{formattedTotalShippingAmount}</Box>
          <Box>{formattedAmount}</Box>
          <Box>{labels[status]}</Box>
        </Box>
      </Box>

      <Box display="flex">
        <Button
          color="primary"
          variant="outlined"
          style={{
            height: '22px',
            fontSize: '11px',
            width: '100%',
            textTransform: 'capitalize',
          }}
          onClick={handleSendOrderUrl}
          data-testid={`shopify-order-history-item-send-url-${orderNumber}`}
        >
          {sendUrlButton}
        </Button>
      </Box>
    </Box>
  );
};

export default OrderHistoryItem;
